import React, { Fragment, useState } from "react";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { makeStyles } from '@mui/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';
//import { useTheme } from '@mui/material/styles';
import {
  DESCRIPCION_POLITICA,
  LARGO_MINIMO,
  LARGO_MAXIMO,
  LARGO_SIN_COMPLEJIDAD,
} from '../../utils/politicaClave';

const theme = createTheme();

const useStyles = makeStyles((theme) => ({
  text_legend: {
    marginBottom: '20px',
    fontSize: '12px',
    color: '#3f51b5'
  },
}));

/*
 * Contador que le muestra al usuario en qué tramo de la política va quedando
 * la clave mientras la escribe: cuánto le falta para el mínimo de
 * LARGO_MINIMO y cuándo llega a LARGO_SIN_COMPLEJIDAD, que es donde deja de
 * exigirse mayúscula, número y carácter especial.
 */
function estadoLargo(clave) {
  const largo = clave ? clave.length : 0;

  if (largo === 0) {
    return { texto: `0/${LARGO_MINIMO} caracteres`, color: 'text.secondary' };
  }

  if (largo > LARGO_MAXIMO) {
    return {
      texto: `${largo} caracteres · supera el máximo de ${LARGO_MAXIMO}`,
      color: 'error.main',
    };
  }

  if (largo < LARGO_MINIMO) {
    const faltan = LARGO_MINIMO - largo;
    return {
      texto: `${largo}/${LARGO_MINIMO} caracteres · falta${faltan === 1 ? '' : 'n'} ${faltan}`,
      color: 'error.main',
    };
  }

  if (largo < LARGO_SIN_COMPLEJIDAD) {
    return {
      texto: `${largo} caracteres · cumple el mínimo. Con ${LARGO_SIN_COMPLEJIDAD} no se te exigirá mayúscula, número ni carácter especial`,
      color: 'info.main',
    };
  }

  return {
    texto: `${largo} caracteres · no se exigen requisitos adicionales`,
    color: 'success.main',
  };
}

/* Alterna entre ver y ocultar la clave, para que el usuario pueda comprobar
   lo que escribió y no se equivoque al repetirla */
function BotonVer(props) {
  const accion = props.visible ? 'Ocultar' : 'Ver';
  return (
    <InputAdornment position="end">
      <IconButton
        aria-label={`${accion} ${props.etiqueta}`}
        title={`${accion} ${props.etiqueta}`}
        onClick={props.alternar}
        onMouseDown={(e) => e.preventDefault()}
        edge="end"
        size="small"
      >
        {props.visible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
      </IconButton>
    </InputAdornment>
  );
}

export default function IngresaClave(props) {
  const classes = useStyles();
  const [verClave, setVerClave] = useState(false);
  const [verClave_rep, setVerClave_rep] = useState(false);
  const largo = estadoLargo(props.clave);

  return <ThemeProvider theme={theme}>
    <Fragment>
      <div className={classes.text_legend}>
        <Typography variant="body1" gutterBottom>
         Para continuar el proceso, debes ingresar tu nueva clave
        </Typography>
      </div>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <TextField
            required
            id="password"
            label="Nueva clave"
            InputLabelProps={{
              shrink: true,
            }}
            helperText={
              <Fragment>
                <Typography
                  component="span"
                  variant="caption"
                  sx={{ display: 'block', fontWeight: 600, mb: 0.5, color: largo.color }}
                >
                  {largo.texto}
                </Typography>
                {DESCRIPCION_POLITICA}
              </Fragment>
            }
            type={verClave ? 'text' : 'password'}
            fullWidth
            onChange={props.leerClave}
            variant="outlined"
            inputProps={{
              style: { fontSize: 20 }
            }}
            InputProps={{
              endAdornment: <BotonVer
                visible={verClave}
                alternar={() => setVerClave(!verClave)}
                etiqueta="la nueva clave"
              />
            }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            required
            id="password_rep"
            label="Repite la clave"
            InputLabelProps={{
              shrink: true,
            }}
            type={verClave_rep ? 'text' : 'password'}
            fullWidth
            onChange={props.leerClave_rep}
            variant="outlined"
            inputProps={{
              style: { fontSize: 20 }
            }}
            InputProps={{
              endAdornment: <BotonVer
                visible={verClave_rep}
                alternar={() => setVerClave_rep(!verClave_rep)}
                etiqueta="la clave repetida"
              />
            }}
          />
        </Grid>
      </Grid>
    </Fragment>
    </ThemeProvider>;
}
